import { makeStyles, createStyles } from '@material-ui/core/styles';
import { getCommon } from './common';

const common = getCommon();
export const stylesCalculator = makeStyles(() =>
    createStyles({
        hide: {
            ...common.display.none,
        },
        container: {
            ...common.display.flex,
            ...common.custom.flexContainerColumnCenter,
            borderRadius: '45px !important',
            width: '300px',
            marginTop: '1rem !important',
        },
        textIconContainer: {
            ...common.display.flex,
            ...common.custom.flexContainerRowMiddle,
        },
        inputContainer: {
            '&:last-of-type': { marginTop: '15px' },
        },
        title: {
            ...common.display.flex,
            ...common.custom.flexContainerColumnCenter,
            marginTop: '10px',
            marginBottom: '15px',
        },
        subtitle: {
            marginTop: '15px',
        },
        mainIcon: {
            ...common.text.color.primaryShade,
            fontSize: '4rem',
            marginBottom: '15px',
        },
        errorText: {
            marginTop: '8px',
            ...common.text.color.danger,
            fontSize: '1rem',
        },
        radioContainer: {
            ...common.custom.flexContainerRowFull,
        },
        radioIcon: {
            ...common.text.color.primaryShade,
            fontSize: '3rem',
            marginLeft: '10px !important',
        },
        radioText: {
            marginLeft: '20px !important',
        },
        calendarInput: {
            '& input': {
                textAlign: 'center',
            },
        },
        selectInput: {
            width: '80%',
            marginTop: '15px',
            '& .MuiSelect-select.MuiSelect-selectMenu.MuiInputBase-input.MuiInput-input': {
                textAlign: 'center',
            },
        },
        contributionContainer: {
            ...common.width.full,
            ...common.display.flex,
            ...common.custom.flexContainerRowCenter,
        },
        contributionTextContainer: {
            ...common.width.full,
            ...common.display.flex,
            ...common.custom.flexContainerRowCenter,
            marginBottom: '6px',
            [common.theme.breakpoints.up('sm')]: {
                display: 'contents !important',
            },
        },
        inputContribution: {
            width: '25%',
            '& input': {
                textAlign: 'center',
            },
        },
        inputContributionText: {
            marginleft: '15px',
            marginRight: '15px',
        },
        calendarText: {
            position: 'relative',
            fontSize: '2rem',
            top: '-10px',
        },
        calendarInputContribution: {
            '& input': {
                textAlign: 'center',
                fontSize: '15px',
            },
            width: '48%',
        },
        periodButtons: {
            ...common.position.relative,
            ...common.display.flex,
            ...common.flexContainer.row.between,
            width: '60px',
            float: 'right',
            top: '-28px',
        },
        deleteButton: {
            ...common.cursor.pointer,
            textAlign: 'center',
            verticalAlign: 'middle',
            lineHeight: '16px',
            fontSize: '1.8rem',
            fontWeight: 800,
            color: 'white',
            backgroundColor: 'orangered',
            width: '23px',
            height: '23px',
            borderRadius: '50%',
        },
        addButton: {
            ...common.cursor.pointer,
            textAlign: 'center',
            verticalAlign: 'middle',
            lineHeight: '26px',
            fontSize: '1.5rem',
            fontWeight: 800,
            color: 'white',
            backgroundColor: 'limegreen',
            width: '23px',
            height: '23px',
            borderRadius: '50%',
        },
        logo: { height: '70px', width: 'auto', marginRight: '20px' },
        titleContainer: { ...common.display.flex, ...common.custom.flexContainerRowFull },
    })
);
